<template>
    <page :busy="busy" :tabs="tabs">
        <router-view @busy="handleBusy"></router-view>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatResponseError } from '../../utils/api';
import page from '../generic/page/page.vue';
export default {
    components: { page },
    data() {
        return {
            busy: false,
        };
    },
    methods: {
        handleBusy(value) {
            this.busy = value;
        },
        async fetchData() {
            try {
                this.handleBusy(true);
                await this.$store.dispatch('quickbooksOld/fetchData');
                if (this.quickbooksData.quickbooks_linked) {
                    await this.fetchAccountMapping();
                }
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({ text: generic || 'Could not fetch quickbooks data' });
            } finally {
                this.handleBusy(false);
            }
        },
        async fetchAccountMapping() {
            try {
                await this.$store.dispatch('quickbooksOld/fetchAccountMapping');
            } catch (e) {
                this.errorToast({ text: 'Could not fetch account mapping' });
            }
        },
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        ...mapGetters('header', ['isImpersonated']),
        ...mapGetters('quickbooksOld', ['quickbooksData', 'accountMapping', 'accountChoices']),
        tabs() {
            const tabs = [
                {
                    title: 'Synchronize',
                    route: '/app/quickbooks-old/synchronize/',
                    active: this.$route.path === '/app/quickbooks-old/synchronize/',
                },
            ];
            if (this.quickbooksData.quickbooks_linked) {
                tabs.push({
                    title: 'Account Mapping',
                    route: '/app/quickbooks-old/account-mapping/',
                    active: this.$route.path === '/app/quickbooks-old/account-mapping/',
                    callback: () => {
                        if (this.accountChoices.length === 0) {
                            this.fetchAccountMapping();
                        }
                    },
                });
                if (this.quickbooksData.has_classes) {
                    tabs.push({
                        title: 'Class Mapping',
                        route: '/app/quickbooks-old/class-mapping/',
                        active: this.$route.path === '/app/quickbooks-old/class-mapping/',
                    });
                }
                tabs.push({
                    title: 'Account Chart',
                    route: '/app/quickbooks-old/account-chart/',
                    active: this.$route.path === '/app/quickbooks-old/account-chart/',
                    callback: () => {
                        if (this.accountChoices.length === 0) {
                            this.fetchAccountMapping()
                        }
                    },
                });
                if (this.isImpersonated) {
                    tabs.push({
                        title: 'Error Logs',
                        route: '/app/quickbooks-old/error-logs/',
                        active: this.$route.path === '/app/quickbooks-old/error-logs/',
                    });
                }
                tabs.push({
                    title: 'Sync Success Logs',
                    route: '/app/quickbooks-old/sync-success-logs/',
                    active: this.$route.path === '/app/quickbooks-old/sync-success-logs/',
                });
                tabs.push({
                    title: 'Sync Fail Logs',
                    route: '/app/quickbooks-old/sync-fail-logs/',
                    active: this.$route.path === '/app/quickbooks-old/sync-fail-logs/',
                });
            }
            return tabs;
        },
    },
};
</script>